import { apiGET, apiIsCancelled } from "./APIHook";
import { useState, useEffect } from "react";
import Moment from "moment";

const parseDT = (dt) => {
  if (dt === undefined) return undefined;
  const result = Moment(dt, "D.M.YYYY [klo] HH:mm");
  if (!result.isValid()) return undefined;
  return result;
};

export const usePriceQuery = (url, data, requiredFields, additionalFields) => {
  const [price, setPrice] = useState({ status: "empty" });

  useEffect(() => {
    const controller = new AbortController();
    const fields = requiredFields(data);

    if (!data.hasValidData(fields)) {
      setPrice({ status: "empty" });
      return;
    }
    const params = { ...data.getQueryData(), ...(additionalFields ?? {}) };

    setPrice({ status: "pending" });
    apiGET(url, {
      signal: controller.signal,
      params,
    })
      .then((result) => {
        if (result.data.status === "error") {
          setPrice({
            status: "error",
            stack: result.data.stack,
          });
          return;
        }
        if (result.data.status === "no_price") {
          setPrice({
            status: "no_price",
          });
          return;
        }

        if (result.data.price !== undefined)
          setPrice({
            status: result.data.status,
            price: result.data.price.toFixed(2),
            vat: result.data.vat.toFixed(2),
            vatPercent: (100 * result.data.vat_percent).toFixed(0),
            pickup: parseDT(result.data.pickup_date),
            delivery: parseDT(result.data.delivery_date),
          });
        else
          setPrice({
            status: "ok",
            raw: result.data.raw,
          });
      })
      .catch((err) => {
        if (apiIsCancelled(err)) {
          console.log("request aborted!");
          return;
        }
        console.error(`HTTP error ${err}`);
        setPrice({
          status: "error",
          stack: "",
        });
      });

    return () => {
      controller.abort();
    };
  }, [data, url, requiredFields]);

  return price;
};
